import React from "react";
import AdminLayout from "../components/AdminLayout";
import MediaLibrary from "../components/MediaLibrary";

export default function AdminMediaLibrary() {
  return (
    <AdminLayout current="library">
      <div className="max-w-7xl" data-testid="admin-media-library-page">
        <div className="mb-10">
          <p className="label-caps text-[color:var(--gold)] text-[10px] tracking-[0.3em] mb-2">Médiathèque</p>
          <h1 className="font-serif text-4xl md:text-5xl mb-3">Gestionnaire de médias</h1>
          <p className="text-white/50 text-sm max-w-2xl">
            Tous les visuels et vidéos du site en un seul endroit. Uploadez, classez par emplacement,
            copiez l'URL pour l'utiliser dans le CMS ou une fiche produit.
          </p>
        </div>
        <MediaLibrary />
      </div>
    </AdminLayout>
  );
}
